import React, { useState, useEffect } from "react";
import {
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  MenuItem,
  InputLabel,
  Box,
  Select,
  FormControl,
  Button,
} from "@mui/material";
import axios from "axios";
import { API_URL } from "../actions/auth";
import { useSelector, useDispatch } from "react-redux";
import { alertMessage } from "../actions/auth";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Switch from "@mui/material/Switch";

const label = { inputProps: { "aria-label": "Edit Form" } };

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function StudentForm() {
  const [formId, setFormId] = useState("");
  const [edit, setEdit] = useState(false);

  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "NAV_COLOR",
      payload: { navColor: "#000c66", navOpacity: 1 },
    });
  }, []);

  function handleSubmit(e) {
    if (edit) {
      e.preventDefault();
      var body = {};
      body["name"] =
        formData.student.firstName + " " + formData.student.lastName;
      body["email"] = formData.parent.email;
      body["phone_number"] = formData.parent.contact;
      body["class"] = formData.academic.admissionFor;
      body["content"] = formData;
      body["form_id"] = makeid(10);
      console.log(API_URL + "/register");
      axios
        .post(API_URL + "/register", JSON.stringify(body))
        .then((res) => {
          console.log("REGISISI");
          dispatch(
            alertMessage(
              "SUCCESS",
              "SUCCESS",
              "Your request has been submitted. Our team will get back to you."
            )
          );
        })
        .catch((err) => {});
    } else {
      alertMessage(
        "ERROR",
        "Error",
        "Submission can only be done in EDIT mode."
      );
    }
  }

  const [formData, setFormData] = useState({
    student: {
      firstName: "",
      middleName: "",
      lastName: "",
      aadharNo: "",
      dateOfBirth: "",
      gender: "",
      religion: "",
      casteIncomeCert: "",
      fatherCasteIncomeCert: "",
      community: "",
      bplFamily: false,
      bplCardNo: "",
      bankDetails: "",
      bhagyalakshmiNo: "",
      reasonForAge: "",
    },
    parent: {
      fatherName: "",
      fatherAadharNo: "",
      fatherProfession: "",
      fatherDesignation: "",
      fatherOrganization: "",
      motherName: "",
      motherAadharNo: "",
      address: "",
      contact: "",
      email: "",
      fax: "",
    },
    academic: {
      admissionFor: "",
      medium: "",
      motherTongue: "",
      previousSchoolName: "",
      previousSchoolMode: "",
      previousSchoolAddress: "",
      previousSchoolSyllabus: "",
      tcIssueDate: "",
    },
    specialDetails: {
      personality: "",
      healthIssues: "",
    },
    declaration: {
      accepted: false,
      date: "",
    },
  });

  function getForm() {
    axios
      .get(API_URL + "/get_form?id=" + formId)
      .then((res) => {
        console.log(res.data);

        dispatch({
          type: "NAV_COLOR",
          payload: { navColor: "#000c66", navOpacity: 1 },
        });

        setFormData(res.data);
      })
      .catch((err) => {
        alertMessage(
          "ERROR",
          "Error",
          "An error occurred while fetching the form data. Please try again later."
        );
      });
  }

  return (
    <div className="main">
      <Sidebar />
      <div className="overlay"></div>

      <div
        className="abouthero"
        style={{
          marginBottom: "100px",
          background:
            "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
            require("../img/asmb.jpg") +
            "')",
        }}
      >
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "30px",
            fontWeight: "bold",
            fontFamily: "Montserrat",
            color:
              state.auth.theme == "dark"
                ? themeStyleDark.primaryButtonTextColor
                : themeStyle.primaryButtonTextColor,
          }}
        >
          View Form
        </div>
      </div>
      <div
        style={{
          width: state.auth.mobileView ? "100%" : "60%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <h2>Student Form</h2>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              label="Form ID"
              variant="outlined"
              value={formId}
              onChange={(e) => {
                setFormId(e.target.value);
              }}
            />

            <Button
              style={{ height: "100%", marginLeft: "15px" }}
              onClick={() => {
                getForm();
              }}
              variant="contained"
              color="primary"
            >
              GET FORM
            </Button>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <h3>Student Details</h3>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="First Name"
                variant="outlined"
                fullWidth
                value={formData.student.firstName}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Middle Name"
                variant="outlined"
                fullWidth
                value={formData.student.middleName}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                variant="outlined"
                fullWidth
                value={formData.student.lastName}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Aadhar Number"
                variant="outlined"
                fullWidth
                value={formData.student.aadharNo}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Date of Birth"
                variant="outlined"
                fullWidth
                type="date"
                value={formData.student.dateOfBirth}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Reason for Below age or Above age"
                fullWidth
                InputProps={{ readOnly: edit }}
                InputLabelProps={{ shrink: true }}
                value={formData.student.reasonForAge}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel>Gender</InputLabel>
              <TextField
                label="Religion"
                variant="outlined"
                fullWidth
                value={formData.student.gender}
                InputProps={{ readOnly: edit }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Community"
                variant="outlined"
                fullWidth
                value={formData.student.community}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Caste Income Certificate"
                fullWidth
                InputProps={{ readOnly: edit }}
                value={formData.student.casteIncomeCert}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                readOnly
                label="Father Caste Income Certificate"
                fullWidth
                value={formData.student.fatherCasteIncomeCert}
              />
            </Grid>
            <Checkbox checked={formData.student.bplFamily} />
            <Grid item xs={12}>
              <TextField
                label="BPL Card No"
                fullWidth
                value={formData.student.bplCardNo}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Bhagyalakshmi Bond No"
                fullWidth
                value={formData.student.bhagyalakshmiNo}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Student Bank Account No."
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.student.bankDetails}
                readOnly
              />
            </Grid>
            <h3>Parent Details</h3>
            <Grid item xs={12}>
              <TextField
                label="Father's Name"
                variant="outlined"
                fullWidth
                value={formData.parent.fatherName}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Mother's Name"
                variant="outlined"
                fullWidth
                value={formData.parent.motherName}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Father's Aadhar No"
                fullWidth
                value={formData.parent.fatherAadharNo}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Mother's Aadhar No"
                fullWidth
                value={formData.parent.motherAadharNo}
                readOnly
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Address"
                fullWidth
                multiline
                rows={3}
                value={formData.parent.address}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Contact"
                fullWidth
                value={formData.parent.contact}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                type="email"
                fullWidth
                value={formData.parent.email}
                readOnly
              />
            </Grid>
            <h3>Academic Details</h3>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Admission For"
                variant="outlined"
                fullWidth
                value={formData.academic.admissionFor}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Medium"
                variant="outlined"
                fullWidth
                value={formData.academic.medium}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Mother Tongue"
                variant="outlined"
                fullWidth
                value={formData.academic.motherTongue}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Name of Previous School"
                fullWidth
                value={formData.parent.previousSchoolName}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Mode of Previous School"
                fullWidth
                value={formData.academic.previousSchoolMode}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Syllabus of Previous School"
                select
                fullWidth
                value={formData.academic.previousSchoolSyllabus}
                readOnly
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="TC Issue Date"
                fullWidth
                value={formData.academic.tcIssueDate}
                readOnly
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Previous School Address"
                fullWidth
                multiline
                rows={3}
                value={formData.parent.previousSchoolAddress}
                readOnly
              />
            </Grid>

            <h3>Special Details</h3>
            <Grid item xs={12}>
              <TextField
                label="Personality"
                variant="outlined"
                fullWidth
                value={formData.specialDetails.personality}
                InputProps={{ readOnly: edit }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Health Issues"
                variant="outlined"
                fullWidth
                value={formData.specialDetails.healthIssues}
                InputProps={{ readOnly: edit }}
              />
            </Grid>

            <h3>Declaration</h3>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox checked={formData.declaration.accepted} readOnly />
                }
                label="Accepted"
              />
            </Grid>
          </Grid>

          <Box mt={3}>
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Box>
        </form>
        <div style={{ height: "200px" }} />
      </div>
    </div>
  );
}

export default StudentForm;
